import {ToursListWrapper} from './tours-list/ToursList'
import {useIntl} from 'react-intl'
import {AzPageHeader} from '../../components/AzPageHeader'

const TourPage = () => {
  const intl = useIntl()

  return (
    <>
      <AzPageHeader
        title={intl.formatMessage({id: 'TOUR_PAGE.TITLE'})}
        subtitle={intl.formatMessage({id: 'TOUR_PAGE.BREADCRUMB'})}
      />
      <ToursListWrapper />
    </>
  )
}

export default TourPage;